export const getPacientes = (axios, painel_codigo) =>
  axios.get(`pacientes/painel/${painel_codigo}`)

export const getPainelEstado = (axios, painel_codigo) =>
  axios.get(`pacientes/painel/${painel_codigo}/estado`)

export const getPaineis = (axios) => axios.get('paineis')
